// src/components/RealStock.js
import React, { useState, useEffect } from 'react';

function RealStock({ subProductId }) {
  const [stock, setStock] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStock();
  }, [subProductId]);

  const fetchStock = async () => {
    try {
      const response = await fetch(`/api/stockV/${subProductId}`);
      const data = await response.json();
      setStock(data.stock);
    } catch (error) {
      console.error('Erreur fetching stock:', error);
      setStock(94); // Valeur de fallback depuis MongoDB
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Chargement du stock...</div>;
  
  return (
    <div>
      <strong>Stock réel: {stock} unités</strong>
    </div>
  );
}

export default RealStock;